import React, { useEffect } from 'react'
import { Button, Col, Nav, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import { getChoosesBySelection } from '../../actions/choosesActions'
import { useDispatch, useSelector } from 'react-redux'
import { finishSelection, getSelection } from '../../actions/selectionsActions'
import Swal from 'sweetalert2'
import useAuth from '../../context/auth/useAuth'


export default function SubMenuSelection({ section, selection }) {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const {client} = useAuth()

    const {chooses} = useSelector(state => state.chooses)
    const {resultselection, loading} = useSelector(state=>state.selections)

    const finishProcess = () => {
        Swal.fire({
            icon: 'question',
            showCancelButton: true,
            showConfirmButton: true,
            text: t('selection.finishProcessQuestion'),
            cancelButtonText: t('global.cancel'),
            confirmButtonText: t('global.yes')
        }).then((result) => {
            if (result.isConfirmed) {
                let isFinishable = true
                for (const choose of chooses) {
                    if (isFinishable) {
                        if (choose.candidateStatus === 1) {
                            if (!choose.dimiss?.reason && choose.candidateOfferLetterStatus === 0) {
                                isFinishable = false
                            }
                        }
                    }
                }
        
                if (isFinishable) {
                    dispatch(finishSelection(selection._id))
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: t('selection.finishError')
                    });
                }
            }
        })
    }

    useEffect(() => {
        if (selection) {
            dispatch(getChoosesBySelection(selection._id))
        }
    }, [selection, dispatch])

    useEffect(() => {
        if (resultselection && resultselection === "successfinishselection") {
            Swal.fire({
                icon: 'success',
                title: t('selection.successFinishSelection')
            });
            dispatch(getSelection(selection._id))
        }
    }, [resultselection, dispatch])

    return (
        <>
            <Row className='my-3'>
                <Col xs={12} md={9}>
                    <Link to={selection?.active ? `/${client?.rol === 'MultiSchool' ? 'multischool' : 'School'}/activeprocesses` : `/${client?.rol === 'MultiSchool' ? 'multischool' : 'School'}/completedprocesses`} className='link-dark'>
                        <div className='py-3 d-flex align-items-center'>
                            <img src="/images/left-arrow.svg" alt="Flecha izquierda" />
                            <h3 className='ms-3 m-0'>{selection?.title}</h3>
                        </div>
                    </Link>
                </Col>
                {
                    selection?.active &&
                    <Col xs={12} md={3}>
                        <div className='d-flex justify-content-end'>
                            <Button variant='primary' type='button' onClick={finishProcess}>
                            {
                                loading
                                ?
                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                :
                                    t("school.selection.closeselection")
                            }
                            </Button>
                        </div>
                    </Col>
                }
            </Row>
            <Row className='mt-3 mb-5'>
                <Col>
                    <Nav defaultActiveKey="/seasons" as="ul" className='selection-submenu'>
                        <Nav.Item as="li">
                            <Nav.Link active={section === "generalData"} as={Link} to={`/${client?.rol === 'MultiSchool' ? 'multischool' : 'School'}/overviewprocess/${selection?._id}`}>{t("selection.submenu.generalData")}</Nav.Link>
                        </Nav.Item>
                        <Nav.Item as="li">
                            <Nav.Link active={section === "candidates"} as={Link} to={`/${client?.rol === 'MultiSchool' ? 'multischool' : 'School'}/overviewprocess/${selection?._id}/candidates`}>{t("selection.submenu.candidates")}</Nav.Link>
                        </Nav.Item>
                        <Nav.Item as="li">
                            <Nav.Link active={section === "precandidates"} as={Link} to={`/${client?.rol === 'MultiSchool' ? 'multischool' : 'School'}/overviewprocess/${selection?._id}/precandidates`}>{t("selection.submenu.precandidates")}</Nav.Link>
                        </Nav.Item>
                        <Nav.Item as="li">
                            <Nav.Link active={section === "refuseds"} as={Link} to={`/${client?.rol === 'MultiSchool' ? 'multischool' : 'School'}/overviewprocess/${selection?._id}/refuseds`}>{t("selection.submenu.refuseds")}</Nav.Link>
                        </Nav.Item>
                        {/* <Nav.Item as="li">
                            <Nav.Link active={section === "requestsSent"} as={Link} to={`/${client?.rol === 'MultiSchool' ? 'multischool' : 'School'}/overviewprocess/${selection?._id}/requestssent`}>{t("selection.submenu.requestsSent")}</Nav.Link>
                        </Nav.Item> */}
                    </Nav>
                </Col>
            </Row>
        </>
    )
}